import { RouteLink } from '../utils/constants/router-link'
import { Navigate } from 'react-router-dom'
import LoginCoachee from './auth/coachee/login.page'

type RoutePath = RouteLink & string

export enum AuthRequirement {
    AUTHENTICATED,
    UNAUTHENTICATED,
}

export type Route = [
    RoutePath[] /* Paths for route */,
    string /* Title */,
    React.FC /* Component to render */,
    AuthRequirement[],
    never? /* State */,
]

export const routes: Route[] = [
    [
        [RouteLink.LOGIN_COACHEE],
        'coacheeLogin',
        LoginCoachee,
        [AuthRequirement.UNAUTHENTICATED],
    ],
    [
        [RouteLink.VERIFY_PASSWORD_COACHEE],
        'coacheeLogin',
        LoginCoachee,
        [AuthRequirement.UNAUTHENTICATED],
    ],
    [
        [RouteLink.OKTA_LOGIN_COACHEE],
        'coacheeLogin',
        LoginCoachee,
        [AuthRequirement.UNAUTHENTICATED],
    ],
    [
        [RouteLink.AUTH_PROVIDOR_LOGIN_COACHEE],
        'coacheeLogin',
        LoginCoachee,
        [AuthRequirement.UNAUTHENTICATED],
    ],
    [
        [RouteLink.ANY],
        'redirecting',
        () => <Navigate to={RouteLink.ERROR} replace={false} />,
        [],
    ],
]
